(function () {
  'use strict';
  /* ---------- Product gallery: swipe, arrows, thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var thumbsWrap = gallery.querySelector('[data-thumbs]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var count = gallery.querySelector('[data-gallery-count]');
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        t.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var t = thumbs[i];
      if (t && thumbsWrap) {
        /* scroll only the thumbnail strip, never the page */
        var horizontal = thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 2;
        if (horizontal) thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        else thumbsWrap.scrollTo({ top: t.offsetTop - thumbsWrap.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
      }
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }
    gallery._goToMedia = function (mediaId) {
      var i = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(mediaId); });
      if (i > -1) goTo(i);
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) setActive(i);
        ticking = false;
      });
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10) || 0); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    /* keep the same photo in view when the phone rotates or the window resizes */
    window.addEventListener('resize', function () {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = current * track.clientWidth;
      track.style.scrollBehavior = '';
    });
  });

})();
